import { ActionReducerMap } from '@ngrx/store';

import { CatalogState } from './state';
import { productsReducer } from './products';
import { sortReducer } from './sort';
import { customPlpReducer } from './custom-plp';


export const catalogReducers: ActionReducerMap<CatalogState> = {
  products: productsReducer,
  sort: sortReducer,
  customplp: customPlpReducer,
};
